import { Message, Loading } from 'element-ui'
import i18n from '@/locale/index.js'
import { getStorage } from '@/utils/util.js'
import { TokenFlagInStorage } from '@/config/config.js'

export async function get(url, options = {}) {
  const requestOptions = {
    method: 'GET'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  let params = ''
  try {
    const data = options.data || {}
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        params = params + '&' + key + '=' + data[key]
      }
    })
  } finally {
    url = url + params.replace(/^&/, '?')
  }

  return http(url, requestOptions, options)
}

export function post(url, options) {
  const requestOptions = {
    method: 'POST'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  const data = options.data || {}
  if (data instanceof FormData) {
    requestOptions['body'] = data
  } else {
    let params = ''
    try {
      
      Object.keys(data).forEach(key => {
        if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
          params = '&' + key + '=' + data[key]
        }
      })
    } finally {
      url = url + params.replace(/^&/, '?')
    }
  }

  return http(url, requestOptions, options)
}

export function del(url, options) {
  const requestOptions = {
    method: 'DELETE'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  let params = ''
  try {
    const data = options.data || {}
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        params = '&' + key + '=' + data[key]
      }
    })
  } finally {
    url = url + params.replace(/^&/, '?')
  }

  return http(url, requestOptions, options)
}

export function put(url, options) {
  const requestOptions = {
    method: 'PUT'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  let params = ''
  try {
    const data = options.data || {}
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        params = params + '&' + key + '=' + data[key]
      }
    })
  } finally {
    url = url + params.replace(/^&/, '?')
  }

  return http(url, requestOptions, options)
}

export function postJson(url, options) {
  const requestOptions = {
    method: 'POST'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  headers['Content-Type'] = 'application/json'
  requestOptions['headers'] = headers

  const data = options.data
  if (data !== undefined && data !== null && JSON.stringify(data) !== '{}') {
    requestOptions['body'] = JSON.stringify(data)
  }

  return http(url, requestOptions, options)
}

export function putJson(url, options) {
  const requestOptions = {
    method: 'PUT'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  headers['Content-Type'] = 'application/json'
  requestOptions['headers'] = headers

  const data = options.data
  if (data !== undefined && data !== null && JSON.stringify(data) !== '{}') {
    requestOptions['body'] = JSON.stringify(data)
  }

  return http(url, requestOptions, options)
}

export function postFormData(url, options) {
  const requestOptions = {
    method: 'POST'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  requestOptions['body'] = options.formData

  return http(url, requestOptions, options)
}

export function upload(file, options) {
  const requestOptions = {
    method: 'POST'
  }

  const headers = options.headers || {}
  const accessToken = getAccessToken()
  if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
    headers['Authorization'] = accessToken
  }
  requestOptions['headers'] = headers

  const formData = new FormData()
  formData.append('file', file)
  requestOptions['body'] = formData

  return http('/api/common/uploadToOss', requestOptions, options)
}

export const convertErrorMessage = (message) => {
  let result = message
  try {
    const params = []
    const i18nKey = message.replace(/\{([^}]+)\}/g, (_, content) => {
      params.push(content)
      return '{}'
    })
    result = i18n.t(i18nKey)
    params.forEach(param => {
      result = result.replace(/\{\}/, param)
    })
  } finally {
    return result
  }
}

async function http(
  url,
  requestOptions,
  {
    showLoading = true,
    loadingText = i18n.t('请稍等') + '...',
    returnOriginal = false,
    showError = true,
    success,
    fail,
    authFail,
    complete,
  }
) {
  let loadingInstance = null
  try {
    if (showLoading !== false) {
      loadingInstance = Loading.service({
        text: loadingText,
        lock: true,
      })
    }
    const response = await fetch(url, requestOptions)
    if (returnOriginal) {
      return response
    }

    const status = response.status
    if (status >= 200 && status < 300) {
      const result = await response.json()
      if (result.code === 200) {
        if (success instanceof Function) {
          success(result)
        }
      } else if (result.code === 20002) {
        if (authFail instanceof Function) {
          authFail()
        }
      } else {
        if (showError) {
          Message({
            message: convertErrorMessage(result.msg),
            type: 'error',
          })
        }
        if (fail instanceof Function) {
          fail()
        }
      }
    } else {
      if (showError) {
        Message({
          message: response.status + ':' + response.statusText,
          type: 'error',
        })
      }
      if (fail instanceof Function) {
        fail()
      }
    }
  } catch(e) {
    return Promise.reject(e)
  } finally {
    if (loadingInstance !== null) {
      loadingInstance.close()
    }
    if (complete instanceof Function) {
      complete()
    }
  }
}

function getAccessToken() {
  const authInfo = getStorage(TokenFlagInStorage) || {}
  return authInfo['access_token'] || ''
}